export const PHONE_MAX_WIDTH = 760;
const PHONE_MAX_HEIGHT = 500;

/** A phone either way up: narrow, or short when held sideways. Matches phone.css. */
export function isPhoneStage(width: number, height: number): boolean {
  return width <= PHONE_MAX_WIDTH || height <= PHONE_MAX_HEIGHT;
}
const CLEARANCE_PX = 8;
/** Room for the date, which sits just above the playback bar. */
const DATE_ROW_PX = 22;

interface OnScreen {
  stageTop: number;
  stageBottom: number;
  /** Where the scene text ends and the playback bar starts, when they are on screen. */
  captionBottom?: number;
  controlsTop?: number;
}

/** The height the text and controls really take on a phone, kept clear of the cast. */
export function cameraInsets(
  stageWidth: number,
  stageHeight: number,
  onScreen?: OnScreen,
): { top: number; bottom: number } {
  if (!isPhoneStage(stageWidth, stageHeight)) {
    return { top: 0, bottom: 0 };
  }
  const { stageTop = 0, stageBottom = stageHeight, captionBottom, controlsTop } = onScreen ?? {};
  const top = captionBottom === undefined ? 0 : captionBottom - stageTop + CLEARANCE_PX;
  const bottom = controlsTop === undefined
    ? 0
    : stageBottom - controlsTop + DATE_ROW_PX + CLEARANCE_PX;
  // Opened-up text can be long. The cast always keeps at least half the height.
  const limit = stageHeight / 2;
  // The bar comes first: it can't move, and a phone held sideways has little height to spare.
  const clearBottom = Math.min(bottom, limit * 0.7);
  return { top: Math.min(top, limit - clearBottom), bottom: clearBottom };
}
